// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  weather: __t.string(),
  particleKind: __t.string(),
  particleDensity: __t.f32(),
  fogDensity: __t.f32(),
  fogColorHex: __t.string(),
  windStrength: __t.f32(),
  wetness: __t.f32(),
};
